import * as ReselectModule from "reselect";
import { ICareTypeListState } from ".";
import { IApplicationState } from "..";

export const selectCareTypeList: ReselectModule.Selector<
  IApplicationState,
  ICareTypeListState
> = (state) => state.careTypeList;
